import { AttachmentsApi } from 'api'

export const uploadAttachment = (file, conversationId) => {
  const data = new FormData()
  data.append('conversationId', conversationId)
  data.append('file', file)

  return AttachmentsApi.post('/attachments', data)
}

export const fetchAttachments = (ids, cancelToken) => {
  return AttachmentsApi.get('/attachments', {
    params: { id: ids },
    cancelToken
  })
}
